import { render, staticRenderFns } from "./NuestrosServicios.vue?vue&type=template&id=6ac2c3e6&scoped=true"
import script from "./NuestrosServicios.vue?vue&type=script&lang=js"
export * from "./NuestrosServicios.vue?vue&type=script&lang=js"
import style0 from "./NuestrosServicios.vue?vue&type=style&index=0&id=6ac2c3e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2c3e6",
  null
  
)

export default component.exports